import React from "react";
import {
  authMiddleware,
  getCurrentUser,
  loginMoodle /* requestAutoLogout */,
  uploadProfilePicture,
  updateUserPicture,
} from "../services/moodle/userauth";
import { STRINGS } from "../utils/strings";
import dic from "../utils/languages.json";
import { useConfig } from "./config";
import { updateUserCustomField, updateUserLanguage } from "../services/moodle/user";

export const AuthContext = React.createContext();

export const normalizeProfileImageUrl = (url, token, baseUrl, cacheKey) => {
  if (!url || !baseUrl) return url;
  let parsedUrl;
  let parsedBaseUrl;
  try {
    parsedUrl = new URL(url);
    parsedBaseUrl = new URL(baseUrl);
  } catch (error) {
    return url;
  }
  const basePath = parsedBaseUrl.pathname.replace(/\/$/, "");
  const pluginPath = `${basePath}/pluginfile.php/`;
  const webservicePluginPath = `${basePath}/webservice/pluginfile.php/`;
  if (parsedUrl.origin !== parsedBaseUrl.origin) return url;
  if (parsedUrl.pathname.startsWith(pluginPath)) {
    parsedUrl.pathname = parsedUrl.pathname.replace(pluginPath, webservicePluginPath);
  } else if (!parsedUrl.pathname.startsWith(webservicePluginPath)) {
    return url;
  }
  parsedUrl.searchParams.set("token", token);
  if (cacheKey !== undefined) {
    parsedUrl.searchParams.set("profileRefresh", String(cacheKey));
  }
  return parsedUrl.toString();
};

/* actions to work on */
export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const { config } = useConfig();
  const [verified, setVerified] = React.useState(false);
  const [lang, setLang] = React.useState(null);
  const [dictionary, setDictionary] = React.useState(dic["en"]);
  const [termsAccepted, setTermsAccepted] = React.useState(false);
  const actions = {
    RefreshAuth: async ({ clearSessionOnError = true, profileImageCacheKey } = {}) => {
      try {
        const token = localStorage.getItem("token");
        const username = localStorage.getItem("username");
        //console.log({ token, username });
        const userObtained = await getCurrentUser({
          token,
          username,
          baseUrl: config.baseURL,
        });
        setUser({
          ...userObtained,
          profileimageurl: normalizeProfileImageUrl(userObtained.profileimageurl, token, config.baseURL, profileImageCacheKey),
          profileimageurlsmall: normalizeProfileImageUrl(userObtained.profileimageurlsmall, token, config.baseURL, profileImageCacheKey),
        });
        let langFormatted = userObtained.lang.includes("es") ? "es" : "en";
        localStorage.setItem("userLang", langFormatted);
        userObtained.lang.includes("es") ? setLang("es") : setLang("en");
        setDictionary(dic[langFormatted]);
        setVerified(true);
      } catch (e) {
        if (clearSessionOnError) {
          console.error("RefreshAuth error, clearing local session:", e);
          localStorage.removeItem("token");
          localStorage.removeItem("username");
          localStorage.removeItem("refresh");
          setUser(null);
          setVerified(true);
        }
        throw e;
      }
    },
    Authenticate: async () => {
      if (localStorage.getItem("token") && !user) {
        /*         console.log('refreshtoken') */
        return Promise.resolve(await actions.RefreshAuth());
      }
      setVerified(true);
    },
    Login: async function (credentials) {
      try {
        const moodleUserInfo = await loginMoodle({
          credentials,
          baseUrl: config.baseURL,
        });
        /* const moodleUserInfo = await authMiddleware({
          token,
          username: credentials.username,
        }); */
        // Manejar política de sitio no aceptada
        /* if (moodleUserInfo.errorcode === 'sitepolicynotagreed') {
          setPendingSitePolicy({
            token: moodleUserInfo.token,
            credentials: credentials,
          });
          // Lanzar error específico para que el componente de login lo maneje
          const error = new Error('SITE_POLICY_NOT_AGREED');
          error.token = moodleUserInfo.token;
          throw error;
        } */
        setUser({
          ...moodleUserInfo,
          profileimageurl: normalizeProfileImageUrl(moodleUserInfo.profileimageurl, moodleUserInfo.token, config.baseURL),
          profileimageurlsmall: normalizeProfileImageUrl(moodleUserInfo.profileimageurlsmall, moodleUserInfo.token, config.baseURL),
        });
        console.log(moodleUserInfo)
        console.log(moodleUserInfo.lang);
        let langFormatted = moodleUserInfo.lang.includes("es") ? "es" : "en";
        setLang(langFormatted);
        setDictionary(dic[langFormatted]);
        localStorage.setItem("userLang", langFormatted);
        setVerified(true);

        if (moodleUserInfo.errorcode === STRINGS.FORCEPASSWORD_ERROR_CODE) {
          localStorage.setItem(
            STRINGS.FORCEPASSWORD_ERROR_CODE,
            STRINGS.FORCEPASSWORD_ERROR_CODE
          );
        }
      } catch (e) {
        throw new Error(e.message);
      }
    },
    login: () => window.location.replace("/"),
    logout: async (moodle = null) => {
      if (user && user.id) {
        localStorage.setItem("newaccess", user.id);
      }
      setUser(null);
      // Detectar idioma del navegador/SO Aprender Steam y setear idioma
      /* let l = "en";
      const navLang =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        "en";
      if (navLang.toLowerCase().startsWith("es")) {
        l = "es";
      }
      console.log(l)
      localStorage.setItem("userLang", l);
      setLang(l); */
      if (moodle.categories || moodle.courses || moodle.grades) {
        moodle.setCourses(null);
        moodle.setCategories(null);
        moodle.setGrades(null);
      }
      localStorage.removeItem(STRINGS.FORCEPASSWORD_ERROR_CODE);
      localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      localStorage.removeItem("username");
      localStorage.removeItem("last-access-cmid");
      localStorage.removeItem("sence_session");
      localStorage.removeItem("current_course");
      localStorage.removeItem("last_login_sence");
      localStorage.removeItem("darkMode");
      localStorage.removeItem("idSence");
      localStorage.removeItem("nru");
      // window.location.replace("/");
    },
    fetchDictionary: async () => {
      /* let url = window.location.href;
      let l = ""; */
      /* insertar funcion que maneje el idioma */
      /* if (url.includes("academy.tuclase")) {
        l = "en";
      } else {
        l = "es";
      } */
      //console.log(dic[l])
      let localStorageLang = localStorage.getItem("userLang");
console.log(localStorageLang)
      if(!localStorageLang){ 
        let l = "en";
        // Detectar idioma del navegador/SO Aprender Steam
        const navLang =
        (navigator.languages && navigator.languages[0]) ||
        navigator.language ||
        "en";
        if (navLang.toLowerCase().startsWith("es")) {
          l = "es";
        }
        console.log(dic[l]);
        if(!user){
          setLang(l);
          setDictionary(dic[l]);
        }
      } else {
        setLang(localStorageLang);
        setDictionary(dic[localStorageLang]);
      }
    },
    toggleLanguage: async () => {
      if (!user) return;
      console.log(lang)
      const newLang = lang === "es" ? "en" : "es";
      console.log(`Cambiando idioma de ${lang} a ${newLang}`);
      // Actualizar contexto
      setLang(newLang);
      setDictionary(dic[newLang]);

      // Actualizar localStorage
      localStorage.setItem("userLang", newLang);

      // Actualizar usuario en contexto
      setUser({ ...user, lang: newLang });
    },
    UpdateProfilePicture: async (file) => {
      if (!user?.id || !user?.token || !config?.baseURL) {
        throw new Error("Profile picture update is unavailable");
      }
      const draftItemId = await uploadProfilePicture({
        token: user.token,
        file,
        baseUrl: config.baseURL,
      });
      await updateUserPicture({
        token: user.token,
        userId: user.id,
        draftItemId,
        baseUrl: config.baseURL,
      });
      try {
        await actions.RefreshAuth({
          clearSessionOnError: false,
          profileImageCacheKey: Date.now(),
        });
        return { refreshed: true };
      } catch (error) {
        return { refreshed: false };
      }
    }
    /* acceptTerms: async () => {
     try {
        await updateUserCustomField({
          token:user.token,
          userid: user.id,
          fieldname: 'terms_accepted',
          value: '1'
        });
        setTermsAccepted(true);
        // Actualizar el usuario en el contexto
        const updatedCustomfields = user.customfields.map(field => 
          field.shortname === 'terms_accepted' 
            ? { ...field, value: '1' } 
            : field
        );
        setUser({ ...user, customfields: updatedCustomfields });
      } catch (error) {
        console.error('Error accepting terms:', error);
        throw error;
      }
    } */
  };



  const value = {
    user,
    setUser,
    verified,
    setVerified,
    lang,
    setLang,
    dictionary,
    setDictionary,
    Authenticate: actions.Authenticate,
    termsAccepted,
    setTermsAccepted,
    acceptTerms: actions.acceptTerms,
    Login: actions.Login,
    logout: actions.logout,
    login: actions.login,
    fetchDictionary: actions.fetchDictionary,
    toggleLanguage:actions.toggleLanguage, // <-- agrega aquí
    UpdateProfilePicture: actions.UpdateProfilePicture,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => React.useContext(AuthContext);
